import { LocalNotifications } from '@capacitor/local-notifications';
import { Capacitor } from '@capacitor/core';
import type { MoveEvent } from '../api/move';

const CHANNEL_ID = 'move-events';
const DAY_MS = 24 * 60 * 60 * 1000;

function moveEventReminderId(eventId: number) {
  return 700000 + (Number(eventId) % 200000);
}

async function ensureMoveNotifPermission() {
  if (Capacitor.getPlatform() === 'web') return false;
  const perm = await LocalNotifications.checkPermissions();
  if (perm.display === 'granted') return true;
  const req = await LocalNotifications.requestPermissions();
  return req.display === 'granted';
}

async function ensureMoveAndroidChannel() {
  if (Capacitor.getPlatform() !== 'android') return;
  try {
    await LocalNotifications.createChannel({
      id: CHANNEL_ID,
      name: 'Human Move',
      description: 'Recordatorios de eventos de Human Move',
      importance: 5,
      vibration: true,
    });
  } catch (e) {
    console.warn('No se pudo crear canal move-events:', e);
  }
}

function formatEventTime(start: Date) {
  return start.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
}

export async function scheduleOneMoveEventReminder(event: MoveEvent) {
  if (Capacitor.getPlatform() === 'web') return false;
  try {
    const granted = await ensureMoveNotifPermission();
    if (!granted) return false;

    const start = new Date(event.fecha_inicio);
    if (Number.isNaN(start.getTime())) return false;

    const fireDate = new Date(start.getTime() - DAY_MS);
    if (fireDate.getTime() <= Date.now()) return false;

    await ensureMoveAndroidChannel();

    const id = moveEventReminderId(event.event_id);
    await LocalNotifications.cancel({ notifications: [{ id }] });

    await LocalNotifications.schedule({
      notifications: [{
        id,
        title: 'Evento Human Move mañana',
        body: `${event.titulo} empieza a las ${formatEventTime(start)}${event.ubicacion_nombre ? ` en ${event.ubicacion_nombre}` : ''}`,
        schedule: { at: fireDate, allowWhileIdle: true },
        channelId: CHANNEL_ID,
        extra: { type: 'move_event_reminder', eventId: String(event.event_id), hours_before: 24 },
      }],
    });
    return true;
  } catch (e) {
    console.warn('Error scheduling move event reminder:', e);
    return false;
  }
}

export async function scheduleManyMoveEventReminders(events: MoveEvent[]) {
  for (const event of events) {
    await scheduleOneMoveEventReminder(event);
  }
}

export async function cancelMoveEventReminder(eventId: number) {
  await LocalNotifications.cancel({ notifications: [{ id: moveEventReminderId(eventId) }] });
}
